export default {"src":"/_next/static/media/dog-blue.7486a221.svg","height":96,"width":97,"blurWidth":0,"blurHeight":0};